<!--<ng-container *ngIf="show">-->
<!--    <mat-progress-bar-->
<!--        [mode]="mode"-->
<!--        [value]="progress"></mat-progress-bar>-->
<!--</ng-container>-->

<!-- <ngx-spinner ></ngx-spinner> -->
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
